import { computeItemId } from './ids.js';
/** Walk every item inside item_list blocks, tagging each with its JSON pointer. */
export function collectDigestItems(report) {
    const out = [];
    for (const [sectionId, section] of Object.entries(report.sections)) {
        section.blocks.forEach((block, bi) => {
            if (block.type === 'item_list') {
                block.items.forEach((item, ii) => {
                    out.push({ item, pointer: `/sections/${sectionId}/blocks/${bi}/items/${ii}` });
                });
            }
        });
    }
    return out;
}
const REQUIRED_WHEN_FEEDBACK = [
    'item_id',
    'source_type',
    'source_ref',
    'semantic_slot',
    'identity_basis',
];
export function validateDigestReport(report) {
    const errors = [];
    const all = collectDigestItems(report);
    // Pass 1: index all present item_ids (for mirror resolution + duplicate detection).
    const seen = new Set();
    const duplicates = new Set();
    for (const { item } of all) {
        if (item.item_id) {
            if (seen.has(item.item_id))
                duplicates.add(item.item_id);
            seen.add(item.item_id);
        }
    }
    // Pass 2: per-item rules.
    for (const { item, pointer } of all) {
        if (item.feedback_enabled) {
            for (const field of REQUIRED_WHEN_FEEDBACK) {
                if (item[field] == null) {
                    errors.push({ pointer, message: `feedback_enabled item is missing "${field}"` });
                }
            }
            if (item.mirrors_item_id) {
                errors.push({
                    pointer,
                    message: 'feedback_enabled is mutually exclusive with mirrors_item_id',
                });
            }
            // item_id must be the deterministic computeItemId of its identity triple.
            if (item.item_id && item.source_type && item.source_ref && item.semantic_slot) {
                const expected = computeItemId({
                    source_type: item.source_type,
                    source_ref: item.source_ref,
                    semantic_slot: item.semantic_slot,
                });
                if (expected !== item.item_id) {
                    errors.push({
                        pointer,
                        message: `item_id ${item.item_id} does not match computeItemId (${expected})`,
                    });
                }
            }
        }
        if (item.mirrors_item_id && !seen.has(item.mirrors_item_id)) {
            errors.push({
                pointer,
                message: `mirrors_item_id ${item.mirrors_item_id} does not resolve to any item in the digest`,
            });
        }
    }
    for (const dup of duplicates) {
        errors.push({ pointer: '(digest)', message: `duplicate item_id ${dup}` });
    }
    return errors;
}
